import api from '@/helper/api'
import axios from 'axios'
// import phpajax from '@/helper/phpajax';

export const baseDataService = {
    async login(UserName,Password)
    {
        const res = await api.login(UserName,Password);
        return res;
    },
    async createSalesOrder(idCustomerMaster,DetailsLines){
        authenticateApi(); 
        const res = await api.createSalesOrder(idCustomerMaster,DetailsLines);
        return res;
    },
    async menu(){
        authenticateApi();
        const res = await axios.get(process.env.VUE_APP_API_SERVER +'menu.php');
        return res.data;
    },
    async products(){
        authenticateApi();
        const res = await api.listTable("products",["isActive,eq,1"],"Description");
        return res.records;
    },
    async tags(){
        authenticateApi();
        const res = await api.listTable("tags","","Name");
        return res.records;
    },
    
    async listUsers(){
        authenticateApi();
        const res = await api.listTable("users","Active,eq,Y","email");
        return res.records;
    },
    async categories(){
        authenticateApi();
        const res = await api.listTable("categories","isdeleted,eq,0","Name");
        return res.records;
    },
    async getCategories(id){
        authenticateApi();
        const res = await api.GetRow("categories",id);
        return res;
    },
    async updateCategories(id,NewValue){
        authenticateApi();
        const res = await api.UpdateRow("categories",id,NewValue);
        return res;
    },
    async createCategories(NewValue){
        authenticateApi();
        const res = await api.CreateRow("categories",NewValue);
        return res;
    },
    async listSalesReps(){
        authenticateApi();
        const res = await api.listTable("users",["Role,eq,sales_rep","Active,eq,Y"],
                                        "Name",-1,"idusers,email,Name,Sername,Role");
        return res.records;
    },
    async listSalesAreas(){
        authenticateApi();
        const res = await api.listTable("SalesAreas","","Name");
        return res.records;
    },
    async listActiveCustomers(){
        authenticateApi();
        const res = await api.listTable("customerMaster",["isDeleted,eq,0"],"Name");
        return res.records;
    },
    async listSalesRepCustomers(){
        authenticateApi();
        const res = await axios.get(process.env.VUE_APP_API_SERVER +'SalesRepCustomer.php');
        return res.data;
    },
    async listContactHeaders(){
        authenticateApi();
        const res = await api.listTable("crm_Contact_types",["isDeleted,eq,0"],"Name");
        return res.records;
    },
    async listCrm_customerHeaderNote(CustomerID){
        authenticateApi();
        const res = await api.listTable("crm_customerHeaderNote",["isDeleted,eq,0",`idCustomerMaster,eq,${CustomerID}`],"idcrm_customerHeaderNote");
        return res.records;
    },
    async listCrm_customerHistory(CustomerID){
        authenticateApi();
        const res = await api.listTable("crm_customerHistory",["isDeleted,eq,0",`idCustomerMaster,eq,${CustomerID}`],"VisitDate,desc");
        return res.records;
    },
    async listCustomer_Contacts(CustomerID){
        authenticateApi();
        const res = await api.listTable("customer_Contacts",["isDeleted,eq,0",`idCustomerMaster,eq,${CustomerID}`],"VisitDate,desc");
        return res.records;
    },
    async listCustomerOrders(idCustomerMaster){
        authenticateApi();
        const res = await api.listCustomerOrders(idCustomerMaster);
        return res;
    },
    async listSalesOrderDetails(idSalsOrderHeader){
        authenticateApi();
        const res = await api.listSalesDetails(idSalsOrderHeader);
        return res;
    },
    async listNewActiveByArea(CustomerCategory,OrderStats){
        authenticateApi();
        const res = await api.listNewActiveByArea(CustomerCategory,OrderStats);
        return res;
    },
    async setOrderConfirm(aAllSalesOrderId,ShipDate){
        authenticateApi();
        const res = await api.setOrderConfirm(aAllSalesOrderId,ShipDate);
        return res;
    },
    async confirmShipment(aAllSalesOrderId){
        authenticateApi();
        const res = await api.confirmShipment(aAllSalesOrderId);
        return res;
    },
    async rejectLine(allDetails,comment){
        authenticateApi();
        const res = await api.rejectLine(allDetails,comment);
        return res;
    },
    async listConfirmedByArea(CustomerCategory,OrderStats,ShipDate){
        authenticateApi();
        const res = await api.listConfirmedByArea(CustomerCategory,OrderStats,ShipDate);
        return res;
    },
}
let TableList =["users","products","tags","customerMaster",
                "salsOrderHeader","salesRepToCustomer","salesOrderDetails",
                "SalesAreas","crm_Contact_types","crm_customerHeaderNote",
                "crm_customerHistory","customer_Contacts"];

TableList.forEach(table => {
    let cap= table[0].toUpperCase()+table.substring(1);
    baseDataService[`get${cap}`] = async function(id){
        authenticateApi();
        const res = await api.GetRow(table,id);
        return res;
    }
    baseDataService[`update${cap}`] = async function(id,NewValue){
        authenticateApi();
        const res = await api.UpdateRow(table,id,NewValue);
        return res;
    },
    baseDataService[`create${cap}`] = async function(NewValue){
        authenticateApi();
        const res = await api.CreateRow(table,NewValue);
        return res;
    }
    
});

async function authenticateApi() {
    let token= localStorage.getItem('token');
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}